module.exports = __webpack_public_path__ + "media/images/number_0_green-26b1741b64a486f98bd994ba1dad961f.png";